import React from 'react'
import LogoRankingSoloTexto from './LogoRankingSoloTexto'
import { VectorBrandType } from './BrandTypes'

export const Logo = ({ theme, className }: VectorBrandType) => {
  return <LogoRankingSoloTexto theme={theme} className={className} />
}
